export default __webpack_public_path__ + "93b18a6d0edff1b3805949e09f408e94.png";